"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TutorialHelpers = void 0;
class TutorialHelpers {
    static flattenSections(tutorial) {
        if (!(tutorial === null || tutorial === void 0 ? void 0 : tutorial.tutorialSteps)) {
            return [];
        }
        const flatSections = [];
        let sectionIndex = 0;
        tutorial.tutorialSteps.forEach((step, stepIndex) => {
            if (step.tutorialSections) {
                step.tutorialSections.forEach((section, sectionIdx) => {
                    flatSections.push({
                        id: `section-${stepIndex}-${sectionIdx}`,
                        sectionId: Number(section.id),
                        stepIndex,
                        sectionIndex: sectionIndex++,
                        title: section.title || 'tutorial.unnamedSection'.t(),
                        stepTitle: step.title || 'tutorial.unnamedStep'.t()
                    });
                });
            }
        });
        return flatSections;
    }
    static findSectionById(flatSections, sectionId) {
        return flatSections.find(s => s.id === sectionId) || flatSections.find(s => s.sectionId === sectionId);
    }
    static findStepAndSection(tutorial, flatSections, sectionId) {
        var _a;
        if (!tutorial) {
            return { step: null, section: null };
        }
        const activeFlatSection = this.findSectionById(flatSections, sectionId);
        if (!activeFlatSection) {
            return { step: null, section: null };
        }
        const step = tutorial.tutorialSteps[activeFlatSection.stepIndex];
        if (!step) {
            return { step: null, section: null };
        }
        const section = (_a = step.tutorialSections) === null || _a === void 0 ? void 0 : _a.find(sec => sec.id === activeFlatSection.sectionId);
        return { step, section: section || null };
    }
    static getSectionsForStep(flatSections, stepIndex) {
        return flatSections.filter(s => s.stepIndex === stepIndex);
    }
}
exports.TutorialHelpers = TutorialHelpers;
